import vInputMultiple from './InputMultiple.vue';

export { vInputMultiple };



// WEBPACK FOOTER //
// ./src/baseComponents/components/InputMultiple/index.js